import PageLayout from './PageLayout';
import { EventDetails } from '@/components/wedding';

const EventsPage = () => (
  <PageLayout testId="events-page">
    <EventDetails />
  </PageLayout>
);

export default EventsPage;
